import { notify } from 'utils/reduxUtils';

export const types = {
  DOWNLOAD_CHARGE_RECEIPTS_ERROR:
    'settings/account/DOWNLOAD_CHARGE_RECEIPTS_ERROR',
  DOWNLOAD_CHARGE_RECEIPTS_REQUEST:
    'settings/account/DOWNLOAD_CHARGE_RECEIPTS_REQUEST',
  DOWNLOAD_CHARGE_RECEIPTS_SUCCESS:
    'settings/account/DOWNLOAD_CHARGE_RECEIPTS_SUCCESS',
};

export const downloadChargeReceipts = {
  error: notify(
    (error) => ({
      type: types.DOWNLOAD_CHARGE_RECEIPTS_ERROR,
      payload: error,
    }),
    'Unable to download charge receipts.',
  ),
  request: () => ({
    type: types.DOWNLOAD_CHARGE_RECEIPTS_REQUEST,
  }),
  success: () => ({
    type: types.DOWNLOAD_CHARGE_RECEIPTS_SUCCESS,
  }),
};
